$(document).on('click', "#galery-carousel-arrow-left", galery_carrousel_left);
$(document).on('click', "#galery-carousel-arrow-right", galery_carrousel_right);

var galery_scrollAmount = 500;


$(document).ready(function(){
    showBrand();
    getBrandBadges();
    getBrandGalery();
});
function showBrand(){
    $('#brand-image-container').css('background-image', 'url("'+brand.path+'")');
    $('#brand-name').html(brand.name);
    $('#brand-description').html(brand.description);
}
function getBrandBadges(){
    let DataSend = {
        brand_id: brand.id
    }
    PostMethodFunction('/WebPage/Brand/Badge/Get',DataSend,  null, showBrandBadges, null);
}
function showBrandBadges(result){
    let appendContent = '';
    $.each(result.data, function(index, value){
        appendContent += '<li class="badge-list-item" style="background-image:url(\'/'+value.path+'\');"></li>';
    });
    $('#badge-list').empty().append(appendContent);
}
function getBrandGalery(){
    let DataSend = {
        brand_id: brand.id
    }
    PostMethodFunction('/WebPage/Brand/Galery/Get',DataSend,  null, showBrandGalery, null);
}
function showBrandGalery(result){
    let appendContent = '';
    $.each(result.data, function(index, value){
        appendContent += '<li class="galery-list-item" style="background-image:url(\'/'+value.path+'\');"></li>';
    });
    $('#galery-list').empty().append(appendContent);
}
function galery_carrousel_left(){
    var container = $('#galery-list');
    container.animate({ scrollLeft: container.scrollLeft() - galery_scrollAmount }, 500);
  }
  function galery_carrousel_right(){
    var container = $('#galery-list');
    container.animate({ scrollLeft: container.scrollLeft() + galery_scrollAmount }, 500);
  }